const { connect } = require('react-redux');
const { context } = require('app-context');
const UserInfo = require('../components/UserInfo');
const { safeWarning } = require('assertions-simplified');
const GetQueryParams = require('utils/get-query-params');
const AuthConstants = require('services/auth-management/constants');

const selectors = context.selectors.all;
const actions   = context.actions;
const internals = {};

module.exports = connect(
    (state) => {

        const { id: loggedInSchoolId } = selectors.getCurrentSchool(state) || {};
        const signupContext = selectors.getSignupContext(state) || {};
        const { schoolId: signupSchoolId } = signupContext;

        const schoolId = loggedInSchoolId || signupSchoolId;
        const school = schoolId ? selectors.getSchoolById(state, schoolId) : null;
        const schoolName = school?.name || null;
        const rolePermissions = selectors.getSignupProfileRolePermissions(state) || {};

        return {
            isAuthenticated: selectors.getIsAuthenticated(state),
            schoolName,
            categories: selectors.getCategories(state),
            includePreferences: true,
            interests: selectors.getInterests(state),
            interestsLoading: selectors.getIsLoadingInterests(state),
            officesLoading: selectors.getIsLoadingOffices(state),
            yearsHiredLoading: selectors.getIsLoadingYearsHired(state),
            onCampusHousingList: selectors.getOnCampusHousingList(state, schoolId) || [],
            offCampusHousingList: selectors.getOffCampusHousingList(state, schoolId) || [],
            transfers: selectors.getBasicTransfers_bySchoolId(state, schoolId),
            signupDetails: selectors.getSignupProfileDetails(state),
            majors: selectors.getMajorsList_bySchoolId(state, schoolId),
            departments: selectors.getDepartmentsList_bySchoolId(state, schoolId),
            yearsHiredList: selectors.getAllYearsHired(state),
            officesList: selectors.getAllOffices(state),
            incomingClassList: selectors.getIncomingClassList_bySchoolId(state, schoolId),
            graduatingClassList: selectors.getGraduatingClassList_bySchoolId(state, schoolId),
            badges: selectors.getBadgesForCurrentUser(state),
            isStudentRoleGroup: selectors.isStudentRoleGroup(state,selectors.getCurrentUserId(state)),
            isParent: selectors.isParentPermission(state),
            rolePermissions,
            role: selectors.getSignupProfileRole(state),
            schoolRoles: selectors.getSchoolRoles(state),
            isCompany: selectors.getSchoolIsCompany(state),
            isCommunity: selectors.getSchoolIsCommunity(state),
            isSchoolOnline: selectors.getSchoolIsOnline(state),
            preferencesFieldsToShow: ['sms'],
            preferencesHeadersToShow: ['communications'],
            requirePhoneForMfa: rolePermissions.mfa === AuthConstants.authFlow.mfaMethods.sms,
            signupContext,
            fieldsPlaceholders: selectors.getFieldsPlaceholders(state, schoolId),
            useProfanityFilter: selectors.getShouldUseProfanityFilter(state, schoolId),
            defaultInterestId: selectors.getDefaultInterestId_bySchoolId(state, schoolId)
        };
    }, {
        onLogout: actions.auth.logout,
        onGoBack: actions.signup.profile.goBack,
        onSubmit: (signupDetails) => (dispatch, getState) => {

            return dispatch(actions.signup.profile.complete(internals.withSignupContext({
                signupDetails,
                state: getState()
            })));
        },
        // TODO I don't think this ever gets called on the signup page.
        onSubmitNoRedirect: (signupDetails) => (dispatch) => { // eslint-disable-line

            return dispatch(actions.profileManagement.updateProfile(signupDetails))
                .then((success) => {

                    // The action creator resolves undefined on failure
                    if (!success) {
                        throw new Error('Update profile failed');
                    }

                    dispatch(actions.alerts.notification.push({
                        message: 'Profile updated'
                    }));
                })
                .catch(safeWarning);
        },
        showNotification: (msg) => actions.alerts.notification.push({ message: msg }),
        onInvalidSubmit: () => actions.alerts.notification.push({ message: 'Please fix invalid form fields' }),
        saveProfileProgress: (signupDetails) => (dispatch, getState) => { // eslint-disable-line

            const { verificationToken } = internals.getSignupContext(getState());

            if (verificationToken) {
                dispatch(actions.signup.profile.updateSignupProgress({ verificationToken, signupDetails }));
            }
        },
        saveProfilePicture: (obj) => async (dispatch, getState) => { // eslint-disable-line

            const { verificationToken } = internals.getSignupContext(getState());

            if (!verificationToken) {
                return;
            }

            return dispatch(actions.signup.profile.updateSignupProgressProfilePic({ verificationToken, pictureDetails: obj }))
                .then((success) => {

                    // The action creator resolves undefined on failure
                    if (!success) {
                        throw new Error('Update profile picture failed');
                    }

                    if (obj.picture !== null) {
                        dispatch(actions.alerts.notification.push({
                            message: 'Profile picture updated'
                        }));
                    }
                    else {
                        dispatch(actions.alerts.notification.push({
                            message: 'Add a personal photo to boost your profile and help connect with students'
                        }));
                    }

                    return success;
                })
                .catch(safeWarning);
        },
        savePreferencesProgress: (prefs) => (dispatch, getState) => { // eslint-disable-line

            const { verificationToken } = internals.getSignupContext(getState());

            if (verificationToken) {
                dispatch(actions.signup.profile.updatePreferencesPresignup({ verificationToken, prefs }));
            }
        }
    }
)(UserInfo);

internals.getSignupContext = (state) => {

    const signupContext = selectors.getSignupContext(state);
    const {
        v,
        email,
        s,
        r
    } = GetQueryParams();

    return {
        ...signupContext,
        verificationToken: signupContext.verificationToken || v,
        schoolId: signupContext.schoolId || (s ? Number(s) : undefined),
        roleId: signupContext.roleId || (r ? Number(r) : undefined),
        email: signupContext.email || email
    };
};

internals.withSignupContext = ({ signupDetails = {}, state }) => {

    const signupContext = internals.getSignupContext(state);

    return {
        ...signupContext,
        ...signupDetails,
        verificationToken: signupDetails.verificationToken || signupContext.verificationToken,
        schoolId: signupDetails.schoolId || signupContext.schoolId,
        roleId: signupDetails.roleId || signupContext.roleId,
        email: signupDetails.email || signupContext.email
    };
};
